














import Vue from 'vue';

export default Vue.extend({
  name: 'SurveyResponseSubjectCellPresenter',
  computed: {
    value(): string {
      return this.$attrs.data && this.$attrs.data.value;
    },
    link(): string {
      const objectType: string = this.$attrs.row.objectType.value;
      const objectId: string = this.$attrs.row.objectId.value;

      return `/sor/info/${objectType}/${objectId}/info`;
    },
  },
});
